<div
  (click)="isDropdownShown = true"
  #itemsFilterTrigger="cdkOverlayOrigin"
  cdkOverlayOrigin
  class="font-semibold text-sm text-navy-900 gap-2 flex h-full items-center w-fit cursor-pointer"
>
  <span>Item Tracked</span>
  <span
    [ngClass]="{ 'rotate-180': isDropdownShown }"
    class="duration-300 ml-2 icon-rounded-triangle text-blue-700 text-size_m"
  ></span>

  <app-overlay-general
    (close)="closeDropdown()"
    [(show)]="isDropdownShown"
    [trigger]="itemsFilterTrigger"
    [overlayPositions]="overlayPositions"
  >
    <div class="rounded-md dropdown-box-shadow bg-color-white p-5 gap-3.5 flex flex-col">
      @for (option of dropdownOptions; track option; let index = $index) {
        <div class="flex gap-2.5 cursor-pointer">
          <app-checkbox
            type="square"
            (ngModelChange)="onOptionChange()"
            [(ngModel)]="selectedOptions[option.value]"
            [binary]="true"
            [id]="'option_' + index"
            [name]="'option_' + index"
            [value]="option.value"
          ></app-checkbox>
          <div (click)="selectedOptions[option.value] = !selectedOptions[option.value]; onOptionChange()">
            {{ option.name }}
          </div>
        </div>
      }
    </div>
  </app-overlay-general>
</div>
